module.exports = __webpack_public_path__ + "components/outside-promo-page/static/skiers-037d9458bd2da7b7f6a54c22a030fc4a.webp";